function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18 10.0032C18 9.69882 17.9083 9.44802 17.725 9.2508L14.1559 5.32154C14.0583 5.21436 13.953 5.13505 13.8399 5.0836C13.7268 5.02787 13.6137 5 13.5005 5C13.2275 5 13.0051 5.09218 12.8335 5.27653C12.6658 5.46088 12.5819 5.69239 12.5819 5.97106C12.5819 6.12969 12.6092 6.26902 12.6638 6.38907C12.7223 6.50911 12.7965 6.61415 12.8862 6.70418L14.15 8.09325L15.8 9.76527L16.2447 9.10289L13.9277 8.97428H7.98298C7.68652 8.97428 7.44858 9.0686 7.26915 9.25723C7.08972 9.44587 7 9.69453 7 10.0032C7 10.3119 7.08972 10.5606 7.26915 10.7492C7.44858 10.9335 7.68652 11.0257 7.98298 11.0257H13.9277L16.2447 10.9035L15.8 10.2412L14.15 11.9068L12.8862 13.2958C12.7965 13.3901 12.7223 13.4973 12.6638 13.6174C12.6092 13.7374 12.5819 13.8746 12.5819 14.0289C12.5819 14.3076 12.6658 14.5391 12.8335 14.7235C13.0051 14.9078 13.2275 15 13.5005 15C13.7385 15 13.955 14.8928 14.15 14.6785L17.725 10.7556C17.9083 10.5584 18 10.3076 18 10.0032Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2 2.10526C2 0.942559 2.89543 0 4 0H10C10.5523 0 11 0.471279 11 1.05263C11 1.63398 10.5523 2.10526 10 2.10526H4V17.8947H10C10.5523 17.8947 11 18.366 11 18.9474C11 19.5287 10.5523 20 10 20H4C2.89543 20 2 19.0574 2 17.8947V2.10526Z",
  fill: "currentColor"
});

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.53f3090b.svg";
export { ForwardRef as ReactComponent };